import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { RequestRequirement } from '../../../../../common/models/request-details.model';

@Component({
  selector: 'lib-requirement-tab',
  imports: [TranslocoPipe],
  templateUrl: './requirement-tab.component.html',
  styleUrl: './requirement-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RequirementTabComponent {
  requirements = input<RequestRequirement[] | undefined>([]);
}
